export default "__VITE_ASSET__C8u2RAQi__"